import { z } from "zod";

import type { ClientsTranslations } from "@/shared/lang/interfaces/clients";

import { MAX_EMAIL } from "./emailValidation";

const PHONE_DIGITS_REGEX = /^\d{7,15}$/;

const MAX_PHONE = 30;
const MAX_COUNTRY = 5;

export type EditClientErrorTranslator = (key: keyof ClientsTranslations) => string;

/**
 * PATCH /internal/clients/:id only accepts tenant contact data (`email`, `phone`, `country`) — identity
 * fields live on the shared `identities` table and are rejected by the backend's whitelist validation. The
 * edit form therefore validates contact fields only; identity is rendered read-only.
 */
export function createEditClientContactSchema(t: EditClientErrorTranslator) {
  return z.object({
    email: z
      .string()
      .trim()
      .min(1, t("validation_email_required"))
      .max(MAX_EMAIL, t("validation_email_max"))
      .email(t("validation_email_invalid")),
    phone: z
      .string()
      .trim()
      .min(1, t("validation_phone_required"))
      .max(MAX_PHONE, t("validation_phone_max"))
      .refine((v) => PHONE_DIGITS_REGEX.test(v.replace(/\D/g, "")), t("validation_phone_required"))
      .transform((v) => v.replace(/\D/g, "")),
    country: z
      .string()
      .trim()
      .min(1, t("validation_country_required"))
      .max(MAX_COUNTRY, t("validation_country_required")),
  });
}

export type EditClientContactValues = z.infer<ReturnType<typeof createEditClientContactSchema>>;
